module.exports = __webpack_public_path__ + "static/img/bottom.3facfa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom.png
// module id = M2uH
// module chunks = 1